import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import type EstimateValues from "../../../../../types/params"
import OneClickDivider from "../../../../components/1Click/OneClickDivider"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidBoardThickness from "../../../../service/visibleValidator/isValidBoardThickness"

import img from "./boardThickness.png"

const getCopperThicknessCondition = (values: EstimateValues) => {
  const obj = {
    "lessThan0.8mm": [
      "0.15mm",
      "0.2mm",
      "0.3mm",
      "0.4mm",
      "0.6mm",
      "0.25mm（Rogers材）",
      "0.5mm（Rogers材）",
      "0.76mm（Rogers材）",
    ] as const,
    "greaterThanOrEqualsTo0.8mm": ["0.8mm", "1.0mm", "1.2mm", "1.6mm", "1.8mm", "2.0mm", "2.4mm", "3.0mm"] as const,
  }

  return {
    "willShowLessThan0.8mm": obj["lessThan0.8mm"].some((value) =>
      isValidBoardThickness(values, ESTIMATE_CONSTANT.板厚[value].value)
    ),

    "willShowGreaterThanOrEqualsTo0.8mm": obj["greaterThanOrEqualsTo0.8mm"].some((value) =>
      isValidBoardThickness(values, ESTIMATE_CONSTANT.板厚[value].value)
    ),
  } as const
}

const 板厚 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { boardThickness: shouldShow } = getDisplayCondition(values)

  const condition = getCopperThicknessCondition(values)
  const shouldShowDivider = condition["willShowLessThan0.8mm"] && condition["willShowGreaterThanOrEqualsTo0.8mm"]

  return (
    <OneClickField isShow={shouldShow} legend="板厚" helpURL={HELP_LINKS.板厚} src={img}>
      <RadioGroup
        name={FIELD_NAMES.板厚}
        selectedValue={values.boardThickness}
        onChange={handlers.radio}
        shouldRender={(value) => isValidBoardThickness(values, value)}
      >
        {condition["willShowLessThan0.8mm"] && (
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT.板厚["0.25mm（Rogers材）"].value}>0.25mm（Rogers材）</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["0.5mm（Rogers材）"].value}>0.5mm（Rogers材）</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["0.76mm（Rogers材）"].value}>0.76mm（Rogers材）</Radio>

            <Radio value={ESTIMATE_CONSTANT.板厚["0.15mm"].value}>0.15mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["0.2mm"].value}>0.2mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["0.3mm"].value}>0.3mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["0.4mm"].value}>0.4mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["0.6mm"].value}>0.6mm</Radio>
          </OneClickFieldStack>
        )}
        {shouldShowDivider && <OneClickDivider />}
        {condition["willShowGreaterThanOrEqualsTo0.8mm"] && (
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT.板厚["0.8mm"].value}>0.8mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["1.0mm"].value}>1.0mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["1.2mm"].value}>1.2mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["1.6mm"].value}>1.6mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["1.8mm"].value}>1.8mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["2.0mm"].value}>2.0mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["2.4mm"].value}>2.4mm</Radio>
            <Radio value={ESTIMATE_CONSTANT.板厚["3.0mm"].value}>3.0mm</Radio>
          </OneClickFieldStack>
        )}
      </RadioGroup>
      <OneClickFieldMessages error={errors?.boardThickness} />
    </OneClickField>
  )
}

export default 板厚
